// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Option_wrapper__3-ztq","icon":"Option_icon__2neqn"};